<template>
  <div
    style="width: 100%; height: 100%"
    ref="autoLayoutContainer"
    @dragover="dragoverEv"
    @dragenter.prevent="handleOuterDragEnter"
    @dragleave.prevent="handleOuterDragLeave"
    @drop="handleAutoLayoutDragover"
  >
    <!--
    @
    -->
    <!--    <div class="layout-row__container" :style="getLayoutBgStyle"  @click.self.stop="setPageLayout">-->
    <!--    目测去掉 @click 事件没有影响，如果加上会造成拖拽组件，鼠标在通栏上放开，此时toolbar的设置项由之前组件变为通栏-->
    <div class="add-layout-page add-last" :class="`add-last-tip-` + layout.id" v-if="isWaterFallPageLayout">放入到新的通栏</div>
    <div class="add-layout-page add-next" :class="`add-next-tip-` + layout.id" v-if="isWaterFallPageLayout">放入到新的通栏</div>
    <div  class="layout-row__container" :style="getLayoutBgStyle">
      <div v-if="layoutBgVideo" class="layout-bg-video">
        <!--        <video src="../../../assets/images/default-video1.mp4" autoplay="true" muted="true" :loop="layoutBgVideo.loopPlay"></video>-->
        <video
          class="video-js"
          poster="../../../assets/images/blank.png"
          :id="'myVideo_pageLayout' + layoutIndex"
          :autoplay="layoutBgVideo.autoplay"
          muted="true"
          :loop="layoutBgVideo.loopPlay"
          :src="videoSrc"
          :class="'myVideo_pageLayout' + layoutIndex"
        ></video>
      </div>
      <!-- 新增背景是为了解决存在视频背景时后面的图片或者颜色【存在透明度可见视频】被遮挡的问题 -->
      <div class="layout-bg-img-color" v-if="layoutBgVideo" :style="getLayoutBgStyle"></div>
      <!-- 专门用来做点击事件的 -->
      <div :style="vdrStyle" @click.self.stop="setInnerPageLayout" :class="'page-layout-container-'+layout.id"></div>
      <!--锚点和飘窗，初次点击选中整个通栏-->
      <div
        @click.self.stop="setPageLayout"
        class="vdr_shade"
        v-if="
          ids.pageLayoutId !== layoutIndex &&
          !$store.state.states.leftMenuDragStatus &&
          ((layout.options.enableBayWindow && !activeInnerItem) || layout.options.inDocument === 'anchor' && ids.pageLayoutId != layoutIndex)
        "
      ></div>
      <!--上下边距-->
      <div
        class="padding-block padding-block-top"
        :class="'padding-block-' + layout.id"
        v-if="!isBigScreenPreview()"
        :style="'height:' + (layout.options.padding ? layout.options.padding[0] : 0) + 'px;line-height:' + (layout.options.padding ? layout.options.padding[0] : 0) + 'px'"
        @mouseenter="paddingMouseenter($event)"
        @mouseleave="paddingMouseleave($event)"
        @click.self.stop="setInnerPageLayout"
        @mousedown="
          $myDrag(
            {
              ctx: _self,
              dragStart: e => paddingResizeStart(e),
              dragging: e => paddingResizingEv(0, e),
              dragEnd: e => paddingResizeStop(0, e)
            },
            $event
          )
        "
      >
        {{ (layout.options.padding ? layout.options.padding[0] : 0) }}px
      </div>
      <div
        class="padding-block padding-block-bottom"
        :class="'padding-block-' + layout.id"
        v-if="!isBigScreenPreview()"
        :style="'height:' + (layout.options.padding ? layout.options.padding[2] : 0) + 'px;line-height:' + (layout.options.padding ? layout.options.padding[2] : 0) + 'px'"
        @mouseenter="paddingMouseenter($event)"
        @mouseleave="paddingMouseleave($event)"
        @click.self.stop="setInnerPageLayout"
        @mousedown="
          $myDrag(
            {
              ctx: _self,
              dragStart: e => paddingResizeStart(e),
              dragging: e => paddingResizingEv(2, e),
              dragEnd: e => paddingResizeStop(2, e)
            },
            $event
          )
        "
      >
        {{ layout.options.padding ? layout.options.padding[2] : 0 }}px
      </div>
      <!-- 移动端 横向标签布局 -->
      <ul
        @mousedown.stop
        style="width: 100%; position: relative;z-index: 3;"
        v-if="request_prefix === 'appStage' && layout.options.isShowTabs"
      >
        <!--通栏里的行-->
        <li
          v-for="(col, index) in layout.layout.rows"
          :class="[
            layout.options.isFullPage ? 'layout-col layout-col-fullPage' : 'layout-col',
            layout.options.childSizeAuto || col.options.childSizeAuto ? 'no-size-limit' : '',
            layout.options.showAutoLayout && !layout.options.direction
              ? 'vertical'
              : layout.options.direction
              ? layout.options.direction
              : '',
            col.options.showAutoLayout && !col.options.direction
              ? 'vertical'
              : col.options.direction
              ? col.options.direction
              : '',
            col.options.showRowColLayout ? col.options.rowColDirection !== 'horizon' ?
            'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : ''
          ]"
          :key="col.id"
          :style="getRowStyle(col, 'row', index, layout.layout.rows, layout.options)"
          v-show="col.options.index === 0 || (col.options.index > 0 && col.options.index === activeIndex + 1)"
        >
          <layout-tree
            :baseComponent="baseComponent"
            :col="col"
            :layoutIndex="layoutIndex + '_' + index"
            :curIndex="index"
            :curId="layout.id"
            :parentLayout="layout.layout"
            :zoom="zoom"
            :id="id"
            :options="layout.options"
            :allLayout="layout"
            :isAnchor="isAnchor"
            :isAccordionLayout="isAccordionLayout"
            :openIndex="openIndex"
          ></layout-tree>
        </li>
      </ul>
      <!--布局-->
      <ul :style="getLayoutWidth(layout.options)" :forceFallback="true" v-else>
        <!--通栏里的行-->
        <template v-for="(col, index) in layout.layout.rows">
          <div v-if="col.options.drawerParams && col.options.drawerParams.isDrawerMode" :key="col.id">
            <el-drawer
              class="positionAbsolute"
              z-index="10001"
              @dragover.prevent.native
              :direction="col.options.drawerParams.direction"
              :visible.sync="drawer"
              :with-header="false"
              :append-to-body="false"
              :modal-append-to-body="false"
              :size="'70%'"
              :class="{ heightFix: drawer }"
            >
              <li
                :class="[
                  layout.options.isFullPage || request_prefix === 'bigScreen' || col.options.width == 1920
                    ? 'layout-col layout-col-fullPage'
                    : 'layout-col',
                  layout.options.childSizeAuto || col.options.childSizeAuto ? 'no-size-limit' : '',
                  layout.options.showAutoLayout && !layout.options.direction ? 'vertical' : layout.options.direction ? layout.options.direction : '',
                  layout.options.showAutoLayout && !layout.options.direction
                    ? 'vertical'
                    : layout.options.direction
                    ? layout.options.direction
                    : '',
                  col.options.showAutoLayout && !col.options.direction
                    ? 'vertical'
                    : col.options.direction
                    ? col.options.direction
                    : '',
                  col.options.showRowColLayout ? col.options.rowColDirection !== 'horizon' ?
                  'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : ''
                ]"
                :style="getRowStyle(col, 'row', index, layout.layout.rows, layout.options)"
              >
                <layout-tree
                  :baseComponent="baseComponent"
                  :col="col"
                  :layoutIndex="layoutIndex + '_' + index"
                  :curIndex="index"
                  :curId="layout.id"
                  :parentLayout="layout.layout"
                  :zoom="zoom"
                  :id="id"
                  :options="layout.options"
                  :isAccordionLayout="isAccordionLayout"
                  :openIndex="openIndex"
                ></layout-tree>
              </li>
            </el-drawer>
          </div>
          <li
            v-else
            :class="[
              layout.options.isFullPage || request_prefix === 'bigScreen' || col.options.width == 1920
                ? 'layout-col layout-col-fullPage'
                : 'layout-col',
              (layout.options.childSizeAuto || col.options.childSizeAuto) && col.rectIds && col.rectIds.length > 0
                ? 'no-size-limit'
                : '',
              layout.options.showAutoLayout && !layout.options.direction
                ? 'vertical'
                : layout.options.direction
                ? layout.options.direction
                : '',
              col.options.showAutoLayout && !col.options.direction
                ? 'vertical'
                : col.options.direction
                ? col.options.direction
                : '',
              col.options.showAutoLayout && !col.options.direction ? 'vertical' : col.options.direction ? col.options.direction : '',
              col.options.showRowColLayout ? col.options.rowColDirection !== 'horizon' ?
              'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : ''
            ]"
            :key="col.id"
            :style="getRowStyle(col, 'row', index, layout.layout.rows, layout.options)"
          >
            <layout-tree
              :baseComponent="baseComponent"
              :col="col"
              :layoutIndex="layoutIndex + '_' + index"
              :curIndex="index"
              :curId="layout.id"
              :parentLayout="layout.layout"
              :zoom="zoom"
              :id="id"
              :options="layout.options"
              :isAnchor="isAnchor"
              :isWaterFall="isWaterFall"
              :isAccordionLayout="isAccordionLayout"
              :openIndex="openIndex"
            ></layout-tree>
          </li>
        </template>
      </ul>
      <div class="vdr_shade" @click.self.stop="setPageLayout" v-if="showPageLayoutVdr"></div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import layoutCell from "./cell"
import VueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import { _throttle, getAllRectInNewLayout, findRectPath, isExist } from "utils"
import layoutTree from "./layoutTree"
import $ from "jquery"
import Video from "video.js"
import { getFirstModuleEncId, getSyetemModuleJson } from "@/utils/initEv.js"
import { deepChangeUid } from "utils"
export default {
  mixins: [],
  name: "cxPageLayout",
  components: {
    draggable,
    layoutCell,
    VueDragResizable,
    layoutTree
  },
  provide() {
    return {
      isSelfModeValue: () => this.isSelfMode,
      selfStageValue: () => this.selfStage,
    }
  },
  data() {
    return {
      ADD_PAGE_LAYOUT_DIS: 20,
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      testData: [1, 2, 4],
      _self: this,
      resizeStartSite: null,
      paddingDragging: false,
      isDragover: false
    }
  },
  props: {
    selfStage: {
      type: Object,
      default: null
    },
    isSelfMode: {
      type: Boolean,
      default: false
    },
    isFullScroll: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    },
    parentOptions: {
      type: Object
    },
    rect: {
      type: Object
    },
    layout: {
      type: [Object, Array],
      required: true
    },
    layoutIndex: {
      type: Number
    },
    id: {
      type: Number
    },
    baseComponent: {
      type: Array
    }
  },
  watch: {
    options: {
      deep: true,
      handler(o, n) {
        this.$forceUpdate()
      }
    },
    layoutBgVideo: {
      deep: true,
      handler(o, n) {
        if (!o) return
        if (o.type === "video") {
          this.videoSrc = this.getVideoSrc(o.objectId)
        }
      }
    }
  },
  computed: {
    originStage() {
      if (this.isSelfMode) return this.selfStage
      return this.$store.state[this.request_prefix]
    },
    isAccordionLayout() {
      return this.layout?.options?.isAccordionLayout || false
    },
    openIndex: {
      get() {
        return this.layout?.options?.hasOwnProperty("openIndex") ? this.layout?.options?.openIndex : -1
      },
      set(val) {
        this.$changeOptionsEV(val, "openIndex", false, null, {
          container_id: this.ids.container_id,
          pageLayoutId: this.layoutIndex
        })
      }
    },
    defaultOpenIndex() {
      return this.layout?.options?.hasOwnProperty("defaultOpenIndex") ? this.layout?.options?.defaultOpenIndex : 0
    },
    isWaterFallPageLayout() {
      return this.layout?.layout?.rows?.[0]?.options?.waterFlow === true
    },
    isAnchor() {
      return this.layout?.options?.inDocument?.includes('anchor')
    },
    isWaterFall() {
      return this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
    },
    showPageLayoutVdr() {
      if ($(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-header')?.length) return false
      if ($(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-footer')?.length) return false
      // 判断是不是当前通栏里面的布局
      if (this.ids.pageLayoutId && this.ids.pageLayoutId.toString().startsWith(this.layoutIndex) && ['header', 'footer'].includes(this.layout.options.inDocument)) return false
      return ['header', 'footer'].includes(this.layout.options.inDocument) &&
        !this.$store.state.states.leftMenuDragStatus &&
        (!this.showRightToolbar || this.ids.pageLayoutId !== this.layoutIndex)
    },
    showRightToolbar() {
      return this.$store.state.states.showRightToolbar
    },
    ids() {
      return this.$store.state.states.activeID
    },
    videoSrc: {
      get() {
        if (this.layoutBgVideo && this.layoutBgVideo.objectId) {
          //  测试写死objectId
          // return this.getVideoSrc("008459aeef672f1bb37f82b0d3f1fd43")
          return this.getVideoSrc(this.layoutBgVideo.objectId)
        }
      },
      set(val) {
        return this.getVideoSrc(val)
      }
    },
    activeIndex() {
      return this.layout.options?.activeIndex || 0
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    layoutCols: {
      get() {
        if (this.request_prefix === "appStage" && this.layout.options?.isShowTabs) return this.newLayout()
        return this.layout
      },
      set(val) {
        this.$emit("update:layout", val)
      }
    },
    // 通栏背景视频
    layoutBgVideo() {
      let optionsBg = this.layoutCols.options.bg
      // 生产有错误的数据，optionsBg不为数组，需要排除
      if (Array.isArray(optionsBg)) {
        let videoSet = optionsBg.find((item, index) => {
             // 为了解决视频上的渐变和图片上传后，不显示。
             if(item.type === "video"){
               return item
             }
        })
        if (videoSet && videoSet.objectId) {
          return videoSet
        }
      }
    },
    // 通栏的样式
    getLayoutBgStyle() {
      let options = this.layoutCols.options
      if (!options) return {}
      let bgStyle = this.bgStyle(options)
      const { enableBayWindow, inDocument } = options
      //  移动端通栏宽度都为100%
      let borderW = ""
      if (Array.isArray(options.borderWidth)) {
        options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += `${options.borderWidth}px`
      }
      const finalBgStyle = {
        paddingTop: enableBayWindow ? 0 : options?.padding?.[0] + "px",
        paddingBottom: enableBayWindow ? 0 : options?.padding?.[2] + "px",
        paddingLeft: enableBayWindow
          ? 0
          : options.isFullPage || this.request_prefix === "appStage" || inDocument === "anchor"
          ? options?.padding?.[3] + "px"
          : "0",
        paddingRight: enableBayWindow
          ? 0
          : options.isFullPage || this.request_prefix === "appStage" || inDocument === "anchor"
          ? options?.padding?.[1] + "px"
          : "0",
        opacity: options.opacity / 100,
        ...bgStyle,
        ...this.publicStyle(options),
        "border-style": options.borderStyle,
        "border-color": this.$parseColor(options.borderColor, {
          isThemeColor: options.borderIsThemeColor
        }),
        "border-width": options.showBorder !== false ? borderW : 0,
        "border-radius":options.borderTopLeftRadius + "px " + options.borderTopRightRadius + "px " + options.borderBottomRightRadius + "px " + options.borderBottomLeftRadius + "px",
      }
      if (this.isFullScroll && !enableBayWindow && !['header', 'footer', 'relativeHeader', "popover"].includes(options.inDocument)) {
        finalBgStyle.minHeight = "100vh"
        finalBgStyle.flexDirection = "column"
        finalBgStyle.justifyContent = "center"
      }
      return finalBgStyle
    },
    publicStyle() {
      return function (options) {
        let style = {}
        const { showBackgroundFilter, backgroundFilter } = options
        if (showBackgroundFilter) {
          style.backdropFilter = `blur(${backgroundFilter}px)`
        }
        return style
      }
    },
    bgStyle() {
      return function (options) {
        if (!options) {
          return {}
        }
        let layoutBg = options.bg
        let containerBg = {
          backgroundImage: ""
        }
        if (!layoutBg || !Array.isArray(layoutBg)) {
          return {}
        }
        layoutBg.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
              break
            case "color":
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage +=
                  dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    getLayoutWidth() {
      // 通栏的样式
      return function (layout) {
        let options = this.layout.options
        let pageWidth = this.$store.state[this.request_prefix].page.pageWidth
        const { enableBayWindow, bayWidth, bayHeight, anchorWidth, inDocument } = layout
        // 设置通栏的宽度
        let width
        if (enableBayWindow) {
          // 飘窗
          width = `${bayWidth}px`
        } else if (inDocument === "anchor") {
          // 锚点
          width = `${anchorWidth || 40}px`
        // } else if (options.isCustomWidth || (options.positionType && options.positionType !== "relative")) {
        } else if (options.isCustomWidth) {
          // 自定义宽度  包括之前的固定定位后的宽度
          width = options.width + options.widthType
        } else if (options.isFullPage || this.request_prefix === "appStage") {
          // 充满或者移动端
          width = "100%"
        } else if (options.inDocument === "drawer") {
          width = "100%"
        } else {
          // 跟随版心
          width = pageWidth + "px"
        }
        width = width || pageWidth + "px"
        return {
          width: width,
          margin: "0 auto",
          position: "relative",
          zIndex: 3
        }
      }
    },
    getRowStyle() {
      // 通栏的样式
      return function (col, cellType, index, colLength, layout) {
        let borderW = ""
        if (Array.isArray(col.options.borderWidth)) {
          col.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${col.options.borderWidth}px`
        }

        let zIndex = 1
        if (cellType === "row") {
          // 行之间设置层级
          zIndex = colLength.length - index
        }
        let options = this.layout.options
        let positionStyle = {}
        if (col.options.positionType && col.options.positionType !== "relative") {
          zIndex = colLength.length + 1
          //处理快捷定位后的偏移
          if(col.options.pxOffset){
            const pxOffset = col.options.pxOffset
            let top = col.options.pTop
            let right = col.options.pRight
            let bottom = col.options.pBottom
            let left = col.options.pLeft
            if(col.options.pTop!== 'auto'){
              if(pxOffset[0] && pxOffset[0] !=='自动'){
                top = `calc(${col.options.pTop} + ${pxOffset[0]}px)`
              }else if(pxOffset[2] && pxOffset[2] !=='自动'){
                top = `calc(${col.options.pTop} - ${pxOffset[2]}px)`
              }
            }
            if(col.options.pRight!== 'auto'){
              if(pxOffset[1] && pxOffset[1] !=='自动'){
                right = `calc(${col.options.pRight} + ${pxOffset[1]}px)`
              }else if(pxOffset[3] && pxOffset[3] !=='自动'){
                right = `calc(${col.options.pRight} - ${pxOffset[3]}px)`
              }
            }
            if(col.options.pBottom!== 'auto'){
              if(pxOffset[2] && pxOffset[2] !=='自动'){
                bottom = `calc(${col.options.pBottom} + ${pxOffset[2]}px)`
              }else if(pxOffset[0] && pxOffset[0] !=='自动'){
                bottom = `calc(${col.options.pBottom} - ${pxOffset[0]}px)`
              }
            }
            if(col.options.pLeft!== 'auto'){
              if(pxOffset[3] && pxOffset[3] !=='自动'){
                left = `calc(${col.options.pLeft} + ${pxOffset[3]}px)`
              }else if(pxOffset[1] && pxOffset[1] !=='自动'){
                left = `calc(${col.options.pLeft} - ${pxOffset[1]}px)`
              }
            }
            positionStyle = {
              position: col.options.positionType,
              top: top,
              left: left,
              right: right,
              bottom: bottom,
              transform: col.options.translate ? `translate${col.options.translate}` : "none"
            }
          }else {
            positionStyle = {
              position: col.options.positionType,
              top: col.options.pTop,
              left: col.options.pLeft,
              right: col.options.pRight,
              bottom: col.options.pBottom,
              transform: col.options.translate ? `translate${col.options.translate}` : "none"
            }
          }
        }
        let bgStyle = this.bgStyle(col.options)
        let boxShadowStyle = this.getBoxShadowStyle(col.options)
        const { enableBayWindow, bayHeight, inDocument } = layout
        // 设置通栏的宽度
        let width
        let margin
        if (col.options.positionType && col.options.positionType !== "relative") {
          // 自定义宽度  包括之前的固定定位后的宽度
          // width = "100%"
          // 目前布局定位之后宽度只能设置百分比
          let colWidth = col.options.widthType && col.options.widthType === 'px' ? `${col.options.width}px`:`${col.options.width}`
          width = `calc(${colWidth} - ${options?.padding?.[1]}px - ${options?.padding?.[3]}px)`
          margin = null
        } else if (options.isFullPage || this.request_prefix === "appStage") {
          width = "100%"
          margin = "0 auto"
        } else {
          margin = `0  ${options?.padding?.[1]}px 0 ${options?.padding?.[3]}px`
          width = `calc(100% - ${options?.padding?.[1]}px - ${options?.padding?.[3]}px)`
        }
        zIndex = col.options.hasOwnProperty("zIndex") ? col.options.zIndex : zIndex
        let showBorder =
          (col.layout?.rows && col.layout.rows.length > 0) || (col.layout?.cols && col.layout.cols.length > 0)
        return {
          display: typeof col.options.isShow === "boolean" && !col.options.isShow ? "none" : "block",
          ...positionStyle,
          ...bgStyle,
          ...this.publicStyle(col.options),
          boxShadow: boxShadowStyle,
          width: width,
          height: enableBayWindow ? `${bayHeight}px !important` : inDocument === "anchor" ? "100%" : null,
          opacity: col.options.opacity / 100,
          margin: enableBayWindow ? null : margin,
          zIndex: zIndex,
          "border-style": col.options.borderStyle,
          "border-color": this.$parseColor(col.options.borderColor, {
            isThemeColor: col.options.borderIsThemeColor
          }),
          "border-width": showBorder && col.options.showBorder !== false ? borderW : 0,
          "border-radius": `${col.options.borderRadius[0]}px ${col.options.borderRadius[1]}px ${col.options.borderRadius[2]}px ${col.options.borderRadius[3]}px`,
          "--custom-margin": options.marginBottom
            ? options.marginBottom + "px"
            : col.options?.marginBottom
            ? col.options?.marginBottom + "px"
            : 0,
        }
      }
    },
    colBgStyle() {
      return function (col) {
        let options = col.options
        if (!options) {
          return {}
        }
        let containerBg = {
          backgroundImage: ""
        }
        if (!options.bg || !Array.isArray(options.bg)) {
          return {}
        }
        options.bg.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize = bg.clipSize
              containerBg.backgroundPosition = bg.alignType
              containerBg.backgroundRepeat = bg.repeatType
              break
            case "color":
              conatinerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                conatinerBg.backgroundImage += dot + this.$parseColor(bg)
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                conatinerBg.backgroundImage += dot + this.$parseColor(bg)
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    getColStyle() {
      return function (col) {
        let padding = ""
        col.options.padding.forEach(item => {
          padding += item + "px "
        })
        let bgStyle = this.colBgStyle(col)
        return {
          ...bgStyle,
          width: col.options.width,
          height: col.options.height + "px",
          padding: padding,
          opacity: col.options.opacity / 100
        }
      }
    },
    drawer: {
      get() {
        for (let i = 0; i < this.layout.layout.rows.length; i++) {
          const col = this.layout.layout.rows[i]
          if (col.options.drawerParams && col.options.drawerParams.isDrawerMode) {
            return col.options.drawerParams.drawer
          }
        }
      },
      set(val) {
        //  需要找到对应通栏的id
        let correlationLayoutId
        for (const rect of this.$store.state[this.request_prefix].page.children[0].children) {
          if (
            rect.options.hasOwnProperty("pluginName") &&
            (rect.options.pluginName.indexOf("listPageNavMenuDrawerPlugin") !== -1 ||
              rect.options.pluginName.indexOf("appMultiFilterDrawerPlugin") !== -1)
          ) {
            correlationLayoutId = rect.options.correlationLayoutId
          }
        }
        if (!correlationLayoutId) return
        console.log("correlationLayoutId", correlationLayoutId)
        this.$changeOptionsEV(val, "drawerParams.drawer", false, null, { pageLayoutId: correlationLayoutId })
      }
    },
    vdrStyle() {
      const { inDocument, isRefHome } = this.layout.options
      // 详情页和列表页，以及平级页面才有遮罩，首页没有
      let pageType = this.$store.state[this.request_prefix].type
      let isSubPage = false
      if (pageType === "listPage" || pageType === "detailPage" || pageType === "equalPage") {
        isSubPage = true
      }
      return {
        position: "absolute",
        left: 0,
        bottom: 0,
        zIndex:
          (["header", "footer"].includes(inDocument) && isRefHome && isSubPage) || this.subPagePreview ? 10000 : 0,
        width: "100%",
        height: "100%"
      }
    },
    subPagePreview() {
      return !!this.$store.state.states.getDataPageIds.pv
    },
    rectIdInContainerOptions() {
      const isHeadLayout =
        this.layout.options.inDocument === "header" || this.layout.options.inDocument === "relativeHeader"
      const isBayWindow = this.layout.options.enableBayWindow
      if (isHeadLayout || isBayWindow) {
        return getAllRectInNewLayout([this.layout])
          .map(it => it.rects || [])
          .flat(1)
          .map(rect_id => {
            const rect = this.getAttrById(this.originStage, { container_id: this.id, rect_id })
            return rect?.rect_id
          })
      } else {
        return []
      }
    },
    activeInnerItem() {
      return this.rectIdInContainerOptions.includes(this.ids.rect_id)
    },
    isOnlyHead() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    }
  },
  methods: {
    handleOuterDragEnter(e) {
      this.isDragover = true
      this.$eventBus.$emit('cancleGridActive', this.layout.id)
    },
    handleOuterDragLeave(e) {
      this.isDragover = false
      sessionStorage.removeItem("dropOverCell")
      if (!this.isWaterFallPageLayout) return
      console.log('鼠标离开', e)
      if (e?.target?.classList?.contains('page-layout-container-' + this.layout.id) && e?.fromElement?.classList?.contains('padding-block-' + this.layout.id)) return
      if (e?.fromElement?.classList?.contains('page-layout-container-' + this.layout.id) && e?.target?.classList?.contains('padding-block-' + this.layout.id)) return
      if (e?.fromElement?.classList?.contains('vue-grid-placeholder')) return
      if (e?.target?.classList?.contains('vue-grid-placeholder') && e?.fromElement?.classList?.contains('padding-block-' + this.layout.id)) return
      if (e?.target?.classList?.contains('vue-grid-placeholder') && e?.fromElement?.classList?.contains('vue-grid-layout')) return
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('page-layout-container-' + this.layout.id)) return
      if (e?.target?.classList?.contains('page-layout-container-' + this.layout.id) && e?.fromElement?.classList?.contains('vue-grid-layout')) return
      if (e?.target?.classList?.contains('padding-block-' + this.layout.id) && e?.fromElement?.classList?.contains('handle-move')) return
      if (e?.target?.classList?.contains('padding-block-' + this.layout.id) && e?.fromElement?.classList?.contains('vue-grid-layout')) return
      if (e?.target?.classList?.contains('handle-move') && e?.fromElement?.classList?.contains('handle-move')) return
      if (e?.target?.classList?.contains('handle-move') && e?.fromElement?.classList?.contains('vue-grid-layout')) return
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('handle-move')) return
      if (e?.target?.classList?.contains('handle-move') && !e.fromElement) return
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('handle')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('auto-layout-component')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('auto-layout-component')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      if (e?.target?.classList?.contains('vue-grid-layout') && e?.fromElement?.classList?.contains('other_content')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      if (e?.target?.classList?.contains('auto-layout-content') && e?.fromElement?.classList?.contains('auto-layout-component')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      if (e?.target?.classList?.contains('auto-layout-component') && e?.fromElement?.classList?.contains('auto-layout-content')) {
        this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        return
      }
      console.log('触发cancle', e)
      // this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
      document.querySelector(`.add-next-tip-${this.layout.id}`) && (document.querySelector(`.add-next-tip-${this.layout.id}`).style.display = 'none')
      document.querySelector(`.add-last-tip-${this.layout.id}`) && (document.querySelector(`.add-last-tip-${this.layout.id}`).style.display = 'none')
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      return JSON.stringify(_attribute)
    },
    // 横向标签布局 处理tab对应通栏索引值 为了显示隐藏
    newLayout() {
      let rows = this.layout.layout.rows
      let index = 0
      rows[0].options.index = 0 //第一行为横向标签索引为0
      for (let i = 1; i < rows.length; i++) {
        if (rows[i].options.tabRowStart) {
          index++
        }
        if (rows[i].options.tabColStart) {
          index++
        }
        rows[i].options.index = index
      }
      return this.layout
    },
    cancleAddGridItem() {
      this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
    },
    dragoverEv(e) {
      // 判断是否是抽屉组件,抽屉组件之在当前通栏内有效
      if (this.layout.options.inDocument === "drawer") {
        sessionStorage.setItem("dropOverCell", true)
      }
      if (e.target?.classList?.contains('vue-grid-placeholder')) return

      if (!this.isWaterFallPageLayout) {
        this.$emit("dragoverEv", e)
        return
      }
      const height = this.$refs.autoLayoutContainer.offsetHeight
      this.isDragover = true

      let finalOffsetY = 0
      if (e.srcElement?.classList?.contains('padding-block-bottom')) {
        // 说明是下padding
        finalOffsetY = e.srcElement.offsetTop + e.offsetY
      } else {
        finalOffsetY = e.offsetY
      }
      console.log("通栏内的dragOver", e.clientY, finalOffsetY, e);
      const shape = localStorage.getItem("dragType")
      this.dragRectAttr = localStorage.getItem('dragTypeData')
      const placeGridItem = this.$refs.autoLayoutContainer.querySelector('.vue-grid-placeholder')
      const lastTips = document.querySelector(`.add-last-tip-${this.layout.id}`)
      const nextTips = document.querySelector(`.add-next-tip-${this.layout.id}`)
      const targetClass = e?.target?.classList
      if (finalOffsetY <= this.ADD_PAGE_LAYOUT_DIS) {
        // 只有首页头部时不允许新增通栏
        if (this.isOnlyHead) return
        if (!(targetClass.contains('padding-block') || targetClass.contains('page-layout-container-' + this.layout.id))) {
          return
        }
        // this.cancleAddGridItem()
        lastTips && (lastTips.style.display = 'flex')
        nextTips && (nextTips.style.display = 'none')
        if (placeGridItem) {
          placeGridItem.style.opacity = 0
        }
        this.$emit("dragoverEv", e, true)
      } else if (finalOffsetY + this.ADD_PAGE_LAYOUT_DIS > height) {
        // 只有首页头部时不允许新增通栏
        if (this.isOnlyHead) return
        // this.cancleAddGridItem()
        if (!(targetClass.contains('padding-block') || targetClass.contains('page-layout-container-' + this.layout.id))) {
          return
        }
        lastTips && (lastTips.style.display = 'none')
        nextTips && (nextTips.style.display = 'flex')
        if (placeGridItem) {
          placeGridItem.style.opacity = 0
        }
        this.$emit("dragoverEv", e, true)
      } else {
        this.$emit("dragoverEv", e, false)
        this.$eventBus.onlyEmit('outer-grid-dragover', this.layout.id, {shape, position: {y: finalOffsetY - (this?.layout?.options?.padding[0] || 0), x: e.offsetX}})
        lastTips && (lastTips.style.display = 'none')
        nextTips && (nextTips.style.display = 'none')
        if (placeGridItem) {
          placeGridItem.style.opacity = 1
        }
      }
    },
    changeOrder() {
      console.log("change 顺序")
    },
    paddingMouseenter(e) {
      if (
        !this.paddingDragging &&
        !this.$store.state.states.isClonePattern &&
        !this.$store.state.states.isOrderPattern
      ) {
        e.currentTarget.classList.add("active")
      }
    },
    paddingMouseleave(e) {
      if (!this.paddingDragging) {
        e.currentTarget.classList.remove("active")
      }
    },
    paddingResizeStart(e) {
      this.paddingDragging = true
      this.resizeStartSite = {
        top: e.clientY
      }
    },
    paddingResizingEv: _throttle(function (paddingIndex, e) {
      let diff = (e.clientY - this.resizeStartSite.top) / this.zoom
      let newVal = this.layout.options?.padding?.[paddingIndex] + diff
      newVal = newVal < 0 ? 0 : newVal
      this.resizeStartSite.top = e.clientY
      this.$changeOptionsEV(parseInt(newVal), "padding." + paddingIndex, false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      })
    }, 5),
    paddingResizeStop(paddingIndex, e, el) {
      let diff = (e.clientY - this.resizeStartSite.top) / this.zoom
      let newVal = this.layout?.options?.padding?.[paddingIndex] + diff
      this.resizeStartSite.top = e.clientY
      this.$changeOptionsEV(parseInt(newVal), "padding." + paddingIndex, false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      })
      this.resizeStartSite = null
      this.paddingDragging = false
      // el.classList.remove("active")
    },
    async getNewRectAttr(rectAttr) {
      if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined"  || !JSON.parse(rectAttr).shape) {
        rectAttr = this.dragRectAttr
      }
      let childItemInfo = sessionStorage.getItem("childItemInfo")
      childItemInfo = JSON.parse(childItemInfo)
      if (childItemInfo.childItemName === "收藏") {
        rectAttr = JSON.parse(rectAttr)
        const _attribute = await getSyetemModuleJson(rectAttr.encId)
        rectAttr = JSON.stringify(_attribute)
      } else if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined" || !JSON.parse(rectAttr).shape) {
        if (childItemInfo.childItemTypeId) {
          let childItem = await getFirstModuleEncId.call(this, childItemInfo.childItemTypeId)
          let type = childItem.content.shape
          let attribute = childItem.content
          const _attribute = JSON.parse(JSON.stringify(attribute))
          rectAttr = this.resetRectAttrOpt(childItem, _attribute)
        } else {
          return
        }
      }
      rectAttr = JSON.parse(rectAttr)
      if (childItemInfo && childItemInfo.childItemTypeId) {
        rectAttr.options.componentTypeName = childItemInfo.childItemTypeName
        rectAttr.options.componentTypeId = childItemInfo.childItemTypeId
        rectAttr.options.name = childItemInfo.childItemTitle ? childItemInfo.childItemTitle : childItemInfo.childItemName
      }
      return rectAttr
  },
    // 从菜单栏拖动组件到页面布局
    async handleAutoLayoutDragover(e) {
      this.isDragover = false
      this.$emit('dropCompleted')
      if (!this.isWaterFallPageLayout) return
      e.stopPropagation()
      // this.$store.commit("states/changeShowRightToolbarStatus", false) // 关闭右侧栏
      // 收到了drop事件，根据相对位置进行判断是新增栅格还是新增通栏
      let finalOffsetY = 0
      if (e.srcElement?.classList?.contains('padding-block-bottom')) {
        // 说明是下padding
        finalOffsetY = e.srcElement.offsetTop + e.offsetY
      } else {
        finalOffsetY = e.offsetY
      }
      const height = this.$refs.autoLayoutContainer.offsetHeight
      if (finalOffsetY < this.ADD_PAGE_LAYOUT_DIS) {
        let rectAttr = e.dataTransfer.getData("rectAttribute")
        const attrs = await this.getNewRectAttr(rectAttr)
        const param = {
          type: this.judgeWaterFallType(attrs), //默认添加第一个布局样式
          insertIndex: this.layoutIndex,
          rectAttr: attrs
        }
        this.$emit('addNewPageLayout', param)
        // this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
        // 向上新增通栏
      } else if (finalOffsetY + this.ADD_PAGE_LAYOUT_DIS > height) {
        let rectAttr = e.dataTransfer.getData("rectAttribute")
        const attrs = await this.getNewRectAttr(rectAttr)
        // 向下新增通栏
        const param = {
          type: this.judgeWaterFallType(attrs), //默认添加第一个布局样式
          insertIndex: this.layoutIndex + 1,
          rectAttr: attrs
        }
        this.$emit('addNewPageLayout', param)
        // this.$eventBus.onlyEmit('outer-grid-cancel', this.layout.id)
      } else {
        const placeGridItem = this.$refs.autoLayoutContainer.querySelector('.vue-grid-placeholder')
        placeGridItem && (placeGridItem.style.opacity = 1)
        this.$eventBus.onlyEmit('outer-grid-dragover-add', this.layout.id)
      }
      document.querySelector(`.add-next-tip-${this.layout.id}`) && (document.querySelector(`.add-next-tip-${this.layout.id}`).style.display = 'none')
      document.querySelector(`.add-last-tip-${this.layout.id}`) && (document.querySelector(`.add-last-tip-${this.layout.id}`).style.display = 'none')
      return
    },
    judgeWaterFallType(attr){
      let type = 0
      if(attr && attr.options && isExist(attr.options.type)){
        return attr.options.type
      }
      return type
    },
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) / this.zoom //鼠标在当前元素上的位置
      let left = Number(e.offsetX) / this.zoom
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect()
      let parentNode = this.getParentNode(e.target)
      if (parentNode.length === 0) {
        _index = _this.options.elementOptions.length
        return _index
      }
      let parentPosition = parentNode[0].getBoundingClientRect()
      //垂直方向排列
      const diffTop = targetPosition.top - parentPosition.top
      let top1 = 0
      _index = _this.pageLayoutList.findIndex((item, index) => {
        top1 += document.getElementsByClassName("page-layout-wrapper")[index].getBoundingClientRect().height
        return top1 > diffTop
      })
      _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      return _index
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    getBoxShadowStyle(options) {
      let tmpStyle = ""
      if (!options.boxShadowH || options.boxShadowH.length === 0) {
        return tmpStyle
      }
      if (Array.isArray(options.boxShadowH)) {
        options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${options.boxShadowH[index]}px ${options.boxShadowV[index]}px ${options.boxShadowBlur[index]}px ${options.boxShadowSpread[index]}px ${this.$parseColor(options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${options.boxShadowH}px ${options.boxShadowV}px ${options.boxShadowBlur}px ${options.boxShadowSpread}px ${this.$parseColor(options.boxShadowColor)}`
      }
      return tmpStyle
    },
    setInnerPageLayout() {
      // 这块是已经处于聚焦状态下才能点击到，所以再次点击的时候不需要关闭右侧栏
      if (['header', 'footer'].includes(this.layout.options.inDocument) && this.showRightToolbar) {
        this.$store.commit("states/changeLogicTextDynamicId", "")
        this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: this.layoutIndex })
        this.$store.commit("states/changeElementType", "cxPageLayout")
      } else {
        this.$emit("setPageLayout")
      }
    },
    setPageLayout(e) {
      this.$emit("setPageLayout")
    },
    // 视频操作相关
    getVideoSrc(objectId) {
      if (objectId) {
        let ypDataUrl = "//yp.mh.chaoxing.com/upload/yunpan/" + objectId + "/status"
        this.instance.get(ypDataUrl).then(res => {
          // this.myPlayer.reset() //重置 video
          // this.myPlayer.src([
          //   {
          //     src: res.data.http
          //   }
          // ])
          // this.myPlayer.load()
          // this.initVideoHandle()
          $(".myVideo_pageLayout" + this.layoutIndex).attr("src", res.data.http)
          return res.data.http
        })
      } else {
        // 测试地址
        // return  require("../../../assets/images/default-video1.mp4")
      }
    },
    initVideoHandle() {
      this.$nextTick(() => {
        const myVideo = document.getElementById("myVideo" + Object.values(this.myid).join(""))
        if (!myVideo) return
        this.myPlayer = Video("myVideo" + Object.values(this.myid).join(""), {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: true,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "100%",
          //设置视频播放器的显示高度（以像素为单位）
          height: "100%",
          poster: "",
          loop: this.loopPlay,
          muted: true //静音自动播放
        })
        this.videoPauseBtnHandle()
      })
    },
    videoPauseBtnHandle() {
      const vedioId = "#video" + Object.values(this.myid).join("")
      const vb = document.querySelector(vedioId + " .vjs-big-play-button")
      const vbIcon = document.querySelector(vedioId + " .vjs-big-play-button .vjs-icon-placeholder")
      if (!vb) return
      vb.style.width = "40px"
      vb.style.height = "40px"
      vb.style.borderStyle = ""
      vb.style.borderWidth = ""
      vb.style.borderColor = ""
      vb.style.backgroundColor = "rgba(255, 255, 255, 0.7)"
      vb.style.borderRadius = "50%"
      vbIcon.style.color = "#000"
      vbIcon.style.lineHeight = "40px"
    },
    // 检查头部绑定预设组件
    checkHeadComponent() {
      const options = this.layout.options
      const headComponentMap = options.headComponentMap
      if (["header", "relativeHeader"].includes(options.inDocument)) {
        if (!options.headComponentMap) {
          const basePrimaryHeadContainerRect = {
            nav: "",
            logo: "",
            login: ""
          }
          this.$changeOptionsEV(
            basePrimaryHeadContainerRect,
            "headComponentMap",
            false,
            "",
            {
              container_id: this.id,
              pageLayoutId: this.layoutIndex
            },
            true
          )
        }
        const rects = this.$store.state[this.request_prefix].page.children[0].children.filter(
          item => this.rectIdInContainerOptions.includes(item.rect_id)
        )
        const navPath = findRectPath(rects, "nav")
        if (navPath) {
          headComponentMap.nav = navPath.rect_id
        }
        const logoPath = findRectPath(rects, "logo")
        if (logoPath) {
          headComponentMap.logo = logoPath.rect_id
        }
        const loginPath = findRectPath(rects, "login")
        if (loginPath) {
          headComponentMap.login = loginPath.rect_id
        }
      }
    },
  },
  mounted() {
    // this.activeTabId = this.options.tabs ? this.options.tabs.filter(tab => tab.isActive)[0].id : "";
    // this.asyncUpdateComponent();
    console.log("this.layout", this.id)
    this.checkHeadComponent()
    this.$initPlugin(this.layout.options.pluginName, [], "layout.options.pluginName")
    this.$eventBus.$on('cancleGridActive', id => {
      if (this.layout.id !== id) {
        this.cancleAddGridItem()
      }
    })
    if (this.isAccordionLayout) {
      this.openIndex = this.defaultOpenIndex
    }
  }
}
</script>

<style scoped lang="scss">
.add-layout-page {
  position: absolute;
  display: none;
  align-items: center;
  width: 100px;
  height: 20px;
  border-radius: 2px;
  justify-content: center;
  background: #fff;
  left: 50%;
  transform: translate(-50%);
  font-size: 12px;
  z-index: 1000;
  border: 1px solid #ccc;
  &.add-last {
    top: -10px;
  }
  &.add-next {
    bottom: -10px;
  }
}
.layout-row {
  width: 100%;
}

.layout-row__container {
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
}

.icon.add-col {
  position: absolute;
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  top: 50%;
  right: -9px;
  margin-top: -9px;
  z-index: 9999;
  cursor: pointer;
}

.layout-col-container {
  position: relative;
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
  height: 100%;
}

.layout-col {
  position: relative;
  box-sizing: content-box;
  width: 100%;
  z-index: 2;
  max-width: 100%;
}
.layout-col[data-level="top-level"] {
  z-index: 10000 !important;
}
.layout-row {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: left;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  max-width: 100%;
  width: 100%;
  overflow: visible;
}

.drag-handle-left {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  left: -10px;
  background-color: green;
  cursor: ew-resize;
}

.drag-handle-right {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  right: -10px;
  background-color: green;
  cursor: ew-resize;
}

/*.auto-layout-container {*/
/*  position: relative;*/
/*  overflow: hidden;*/
/*  min-width: 20px;*/
/*  min-height: 20px;*/
/*  outline: 1px solid var(--themeColor);*/
/*}*/

.padding-block {
  position: absolute;
  left: 0;
  right: 0;
  cursor: ns-resize;
  background-color: transparent;
  z-index: 1;
  font-size: 0;
  color: var(--themeColor);
}

.padding-block.active {
  font-size: 14px;
  background-color: rgba(43, 103, 255, 0.12);
}

.padding-block-top {
  top: 0;
}

.padding-block-bottom {
  bottom: 0;
}

.row-sets {
  position: absolute;
  top: -9px;
  right: -9px;
  z-index: 9999;
}

.row-sets-toolbar {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 999px;
  background-color: #3d3d3d;
  padding: 0 8px;
  height: 32px;
}

.row-sets-toolbar .icon {
  display: inline-block;
  font-size: 14px;
  width: 32px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  color: #fff;
  cursor: pointer;
}

.row-sets-toolbar .icon:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.row-sets-toolbar:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent;
}

.default-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
}

.default-icon:hover {
  transform: scale(1.3);
}

.mover {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transform: scale(1.3);
}
.isDrag-over:before {
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: var(--themeColor);
  top: -2px;
  content: "";
}
::v-deep.layout-col-fullPage .layout-col:last-child .layout-sets .cell-sets-toolbar,
::v-deep.layout-col-fullPage > .layout-container:last-child > .layout-sets .cell-sets-toolbar {
  right: -10px;
  left: auto;
  transform: translateX(0);
}
::v-deep.layout-col-fullPage .layout-col:last-child .layout-sets .cell-sets-toolbar:before,
::v-deep.layout-col-fullPage > .layout-container:last-child > .layout-sets .cell-sets-toolbar:before {
  left: auto;
  right: 14px;
  transform: translateX(0);
}
/*处理 字段长度不确定的情况  如接口返回的作者：**   时间：**  等*/
/*处理方式为 vdr尺寸自适应  容器高度自适应*/
/*目前为内部人员使用，所以交互上比较粗糙*/
::v-deep .layout-col.no-size-limit,
::v-deep .layout-col.no-size-limit .layout-container,
::v-deep .layout-col.no-size-limit .layout-columns,
::v-deep .layout-col.no-size-limit .layout-cell-container {
  height: unset !important;
  max-height: unset !important;
}
::v-deep .layout-col.no-size-limit.vertical .layout-cell-container > .vdr {
  display: block;
  margin-top: var(--custom-margin);
}
::v-deep .layout-col.no-size-limit.vertical .layout-cell-container > .vdr:first-child {
  margin-top: 0;
}
::v-deep .layout-col.no-size-limit.horizon .layout-cell-container > .vdr {
  display: inline-block;
  margin-left: var(--custom-margin);
}
::v-deep .layout-col.no-size-limit.horizon .layout-cell-container > .vdr:first-child {
  margin-left: 0;
}
::v-deep .layout-col.no-size-limit .layout-cell-container > .vdr {
  position: relative;
  /* width: unset !important;
  height: unset !important; */
  transform: none !important;
}
::v-deep .el-drawer .el-drawer__body {
  height: inherit;
}
::v-deep .el-drawer .layout-col,
::v-deep .el-drawer .layout-col .layout-columns {
  height: 100% !important;
}
::v-deep .el-drawer {
  background-color: transparent;
  box-shadow: none;
}
.positionAbsolute {
  position: absolute;
}
.positionAbsolute.heightFix {
  position: fixed !important;
}
.layout-bg-video,
.layout-bg-img-color{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  border-radius: inherit; /* 通栏设置圆角，背景视频没有裁剪圆角 */
  overflow: hidden;
}
.layout-bg-video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* 行列通栏布局 */
/* ::v-deep .layout-col.row-col-layout.vertical-layout .layout-cell-container > .vdr {
  margin-top: var(--custom-margin-bottom) !important;
  margin-right: var(--custom-margin-right) !important;
} */
/* ::v-deep .layout-col.row-col-layout.horizon-layout .layout-cell-container > .vdr {
  display: inline-block;
  margin-left: var(--custom-margin-bottom) !important;
  margin-bottom: var(--custom-margin-right) !important;
} */
/* ::v-deep .layout-col.row-col-layout.vertical-layout .layout-cell-container > .vdr:first-child {
  margin-top: 0 !important;
}
::v-deep .layout-col.row-col-layout.horizon-layout .layout-cell-container > .vdr:first-child {
  margin-left: 0 !important;
} */
::v-deep .layout-col.row-col-layout .layout-cell-container > .vdr,
::v-deep .layout-row.row-col-layout .layout-cell-container > .vdr,
::v-deep .layout-col.row-col-layout .layout-cell-container > .accordionContent > .vdr,
::v-deep .layout-row.row-col-layout .layout-cell-container > .accordionContent > .vdr {
  flex-shrink: 0; /* flex布局不改变子元素宽高 */
  position: relative;
  transform: none !important;
}
/* 开启自动布局下拖拽辅助线 */
::v-deep .row-col-layout .layout-cell-container > .dragging,
::v-deep .row-col-layout .hover-active .layout-cell-container,
::v-deep .row-col-layout .hover-active .layout-cell-container > .vdr .vdr_shade,
::v-deep .row-col-layout .hover-active .layout-cell-container > .accordionContent > .vdr .vdr_shade {
  cursor: grab !important;
}
::v-deep .row-col-layout .hover-active .layout-cell-container > .dragging > div {
  opacity: 0.5 !important;
}
::v-deep .vertical-layout .layout-cell-container > .ghost::after,
::v-deep .vertical-layout .layout-cell-container > .accordionContent > .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--themeColor);
}
/* 以下custom-margin取的cell.vue里面的值 */
::v-deep .vertical-layout .layout-cell-container > .ghost.before::after {
  top: var(--custom-margin);
}
::v-deep .vertical-layout .layout-cell-container > .ghost.after::after {
  bottom: var(--custom-margin);
}
::v-deep .horizon-layout .layout-cell-container > .ghost::after{
  content: "";
  position: absolute;
  top: 0;
  width: 3px;
  height: 100%;
  background: var(--themeColor);
}
::v-deep .horizon-layout .layout-cell-container > .ghost.before::after{
  top: 0;
  left: var(--custom-margin);
}
::v-deep .horizon-layout .layout-cell-container > .ghost.after::after{
  left: auto;
  right: var(--custom-margin);
}
::v-deep .row-col-layout .layout-cell-container > .vdr.before:first-child::after {/* 第一个元素前不要偏移值 */
  top: 0 !important;
  left: 0 !important;
}
::v-deep .row-col-layout .layout-cell-container > div:last-of-type::after {/* 最后一个元素后不要偏移值 */
  bottom: 0 !important;
  right: 0 !important;
}
::v-deep .row-col-layout .layout-cell-container .ref-line {/* 隐藏对齐辅助线 */
  display: none !important;
}
.vdr_shade {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  background: transparent;
}
.select-active .vdr_shade {
  display: none;
}
</style>
